// Shapes returned by the manual diagnostic endpoints, shared by the
// Diagnostics page and the two result panels it renders.

export interface PingResult {
  target: string;
  success: boolean;
  latencyMs: number;
  packetLoss: number;
  error?: string;
  durationMs: number;
}

export interface DiagResponse {
  totalTargets: number;
  concurrency: number;
  succeeded: number;
  failed: number;
  totalDurationMs: number;
  pingLimiterCap: number;
  workersBusy: number;
  workersTotal: number;
  results: PingResult[];
}

export interface ProxyStepResult {
  name: string;
  success: boolean;
  severity?: 'warn' | 'info';
  latency: number;
  error?: string;
  notes?: string[];
}

export interface ProxyTestResult {
  proxy: string;
  protocol: string;
  success: boolean;
  latencyMs: number;
  durationMs: number;
  state: string;
  steps: ProxyStepResult[];
  error?: string;
}

export interface ProxyDiagResponse {
  totalProxies: number;
  succeeded: number;
  failed: number;
  totalDurationMs: number;
  targetURL: string;
  maxLatencyMs: number;
  results: ProxyTestResult[];
}

export interface ProxyEntry {
  protocol: string;
  host: string;
  port: number;
  login: string;
  password: string;
}

export interface DiagWorker {
  id: string;
  name: string;
  country?: string;
  city?: string;
  publicIp?: string;
  live?: { online: boolean };
}

// Vantage point returned with every diagnostic: which worker ran it and from
// where — recorded at check time, not looked up afterwards.
export interface CheckedBy {
  workerName?: string;
  workerIP?: string;
  workerCountry?: string;
}

/** checkedFromLabel renders the vantage point as one line, or null when the
 *  worker did not identify itself. */
export function checkedFromLabel(cb: CheckedBy | null): string | null {
  if (!cb?.workerName) return null;
  const parts = [cb.workerName];
  if (cb.workerCountry) parts.push(cb.workerCountry);
  if (cb.workerIP) parts.push(cb.workerIP);
  return parts.join(' · ');
}
